import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { ContactCard } from "@/components/site/ContactCard";
import { QuoteForm } from "@/components/quote/QuoteForm";

export default function Quote() {
  return (
    <>
      <Seo title="Free Quote | Handyman Services Oxfordshire"
        description="Request a free, no-obligation quote for home improvements, garden maintenance or house cleaning anywhere in Oxfordshire. Add photos of the job for a faster reply." />
      <PageHero testId="quote-hero" eyebrow="Free quotation" lines={["Request your", "free quote."]}
        intro="Tell us a little about the job. It only takes a couple of minutes, and there's no obligation." />
      <section className="bg-[var(--grey)] py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 grid gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <div className="rounded-[1.75rem] bg-white p-6 sm:p-10 shadow-sm"><QuoteForm /></div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4"><div className="lg:sticky lg:top-32"><ContactCard /></div></Reveal>
        </div>
      </section>
    </>
  );
}
